export default __webpack_public_path__ + "media/f4547952c7fbaf33681f2b06a5cc6033e21676d2be223d60315e398b1fe1377a.svg";